import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { FC } from "react";

const MAX_STATUS_REASON_LENGTH = 512;

interface IStatusReasonForm {
  reason: string;
  otherReason: string;
  setReason: React.Dispatch<React.SetStateAction<string>>;
  setOtherReason: React.Dispatch<React.SetStateAction<string>>;
  validationErrors: any;
}

export const StatusReasonForm: FC<IStatusReasonForm> = ({
  reason,
  otherReason,
  setReason,
  setOtherReason,
  validationErrors,
}) => {
  return (
    <>
      <FormControl error={validationErrors.reason} required>
        <InputLabel>Reason for decision</InputLabel>
        <Select
          variant='filled'
          name={"declineReason"}
          label={"Decline reason"}
          value={reason}
          renderValue={(value) => value}
          onChange={(e: any) => {
            delete validationErrors.reason;
            setReason(e.target.value);
          }}
        >
          {[
            "Incomplete File",
            "Inconsistent Data",
            "Wrong Region",
            "Criminal Record",
            "Sanctions",
            "PEP",
            "Adverse Media",
            "Other",
          ].map((reason) => (
            <MenuItem value={reason} key={reason}>
              {reason}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        error={validationErrors.otherReason}
        label='Specify reason'
        name='other'
        required={reason === "Other"}
        size='small'
        margin='normal'
        value={otherReason}
        multiline
        rows={Math.min(10, Math.ceil(otherReason.length / 50))}
        onChange={(e: any) => {
          const filteredValue = e.target.value.replace(/[\r\n]/g, '');
          setOtherReason(filteredValue);
        }}
        inputProps={{
          maxLength: MAX_STATUS_REASON_LENGTH,
        }}
      />
    </>
  );
};
